import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { INVALID_ID } from '../../../../../../global/constants/ap_id_constants';

export interface IComment {
  created_ts: string;
  id: number;
  message: string;
  recipient: number;
  sender: number;
  updated_ts: string;
}

export type APCommentsModel = ITypedModel<IComment>;

angular.module('capability-ng-academic-planner').factory(
  'ngAPCommentsModel',
  () =>
    new Model<IComment>({
      created_ts: '',
      id: INVALID_ID,
      message: '',
      recipient: INVALID_ID,
      sender: INVALID_ID,
      updated_ts: ''
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_comments/models/ap_comments_model.ts